import {
  convertHtmlToFormat,
  countMobileDeMarkupOverhead,
  DEFAULT_PLATFORM_FORMAT,
  PLATFORM_FORMAT_MAP,
} from '@dms/shared';

type PlatformInfo = {
  code: string;
  title: string;
  enabled: boolean;
};

export type OverLimitPlatform = {
  platformTitle: string;
  count: number;
  limit: number;
};

export function getOverLimitPlatforms(
  descriptionHtml: string | null,
  platforms: Array<{platform: PlatformInfo}>
): OverLimitPlatform[] {
  if (!descriptionHtml) {
    return [];
  }

  const overLimit: OverLimitPlatform[] = [];

  platforms
    .filter(({platform}) => platform.enabled)
    .forEach(({platform}) => {
      const config = PLATFORM_FORMAT_MAP[platform.code] ?? DEFAULT_PLATFORM_FORMAT;
      const {characterLimit} = config;

      if (characterLimit === null) {
        return;
      }

      const converted = convertHtmlToFormat(descriptionHtml, config.format);
      const isMobileDe = config.format === 'mobileDe';
      const markupOverhead = isMobileDe ? countMobileDeMarkupOverhead(converted) : 0;
      const count = isMobileDe ? converted.length - markupOverhead : converted.length;

      if (count > characterLimit) {
        overLimit.push({
          platformTitle: platform.title,
          count,
          limit: characterLimit,
        });
      }
    });

  return overLimit;
}
